import type { TimelineNode, TimelineType } from "@/types/content";
import { timelineMeta } from "@/utils/timeline";

const iconMap: Record<TimelineType, string> = {
  start: "ri-megaphone-line",
  update: "ri-refresh-line",
  reversal: "ri-exchange-line",
  followup: "ri-arrow-right-circle-line",
};

export default function EventTimeline({ nodes }: { nodes: TimelineNode[] }) {
  return (
    <div className="relative">
      {nodes.map((node, index) => {
        const meta = timelineMeta[node.type];
        return (
          <div key={`${node.time}-${index}`} className="relative flex gap-4 md:gap-5 pb-7 last:pb-0">
            {index !== nodes.length - 1 ? (
              <span className="absolute left-[15px] top-9 bottom-0 w-px bg-background-300" />
            ) : null}
            <span
              className={`relative z-10 w-8 h-8 rounded-full flex items-center justify-center shrink-0 text-background-50 ${meta.dot}`}
            >
              <i className={iconMap[node.type]} />
            </span>
            <div className="flex-1 min-w-0 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <div className="flex flex-wrap items-center gap-2">
                <span className={`px-2 py-0.5 rounded-full border text-[11px] ${meta.chip}`}>
                  {meta.label}
                </span>
                <span className="text-xs text-foreground-500">{node.time}</span>
              </div>
              <h3 className="mt-2 font-heading text-base font-bold text-foreground-950">{node.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}